import img from './../Assets/img.avif'
import img2 from './../Assets/img2.avif'
import img3 from './../Assets/img3.avif'
import img4 from './../Assets/img4.avif'
import img5 from './../Assets/img5.avif'
import img6 from './../Assets/img6.avif'
import img7 from './../Assets/img7.avif'
import img8 from './../Assets/img8.avif'
import img9 from './../Assets/img9.avif'

 export const Data =[
    {
        id:1,
        imgSrc:img,
        destTitle:'Bora Bora',
        location:'New Zeland',
        grade:'CULTURAL RELAX',
        fees:'$700',
        discription: ' the epitom of romance sit amet consectetur adipisicing elitSunt illo quisquam voluptatum debitis rerum, vel corrupti recusandae animi excepturi  totam veritatis cumque fuga reiciendis dolor accusantium '

    },
    {
        id:2,
        imgSrc:img2,
        destTitle:'Machu Picchu',
        location:'Peru',
        grade:'CULTURAL RELAX',
        fees:'$600',
        discription: ' the epitom of romance sit amet consectetur adipisicing elitSunt illo quisquam voluptatum debitis rerum, vel corrupti recusandae animi excepturi  totam veritatis cumque fuga reiciendis dolor accusantium '

    },
    {
        id:3,
        imgSrc:img3,
        destTitle:'Great Barrier ',
        location:'Australia',
        grade:'CULTURAL RELAX',
        fees:'$700',
        discription: ' the epitom of romance sit amet consectetur adipisicing elitSunt illo quisquam voluptatum debitis rerum, vel corrupti recusandae animi excepturi  totam veritatis cumque fuga reiciendis dolor accusantium '

    },
    {
        id:4,
        imgSrc:img4,
        destTitle:'Cappadocia',
        location:'Turkey',
        grade:'CULTURAL RELAX',
        fees:'$800',
        discription: ' the epitom of romance sit amet consectetur adipisicing elitSunt illo quisquam voluptatum debitis rerum, vel corrupti recusandae animi excepturi  totam veritatis cumque fuga reiciendis dolor accusantium '

    },
    {
        id:5,
        imgSrc:img5,
        destTitle:'Guanajuato',
        location:'Mexico',
        grade:'CULTURAL RELAX',
        fees:'$1100',
        discription: ' the epitom of romance sit amet consectetur adipisicing elitSunt illo quisquam voluptatum debitis rerum, vel corrupti recusandae animi excepturi  totam veritatis cumque fuga reiciendis dolor accusantium '

    },
    {
        id:6,
        imgSrc:img6,
        destTitle:'Cinque Terre',
        location:'Italy',
        grade:'CULTURAL RELAX',
        fees:'$840',
        discription: ' the epitom of romance sit amet consectetur adipisicing elitSunt illo quisquam voluptatum debitis rerum, vel corrupti recusandae animi excepturi  totam veritatis cumque fuga reiciendis dolor accusantium '

    },
    {
    id:7,
    imgSrc:img7,
    destTitle:'Angkor Wat',
    location:'Combodia',
    grade:'CULTURAL RELAX',
    fees:'$790',
    discription: ' the epitom of romance sit amet consectetur adipisicing elitSunt illo quisquam voluptatum debitis rerum, vel corrupti recusandae animi excepturi  totam veritatis cumque fuga reiciendis dolor accusantium '

},
{
    id:8,
    imgSrc:img8,
    destTitle:'Taj Mahal',
    location:'India',
    grade:'CULTURAL RELAX',
    fees:'$900',
    discription: ' the epitom of romance sit amet consectetur adipisicing elitSunt illo quisquam voluptatum debitis rerum, vel corrupti recusandae animi excepturi  totam veritatis cumque fuga reiciendis dolor accusantium '

},
{
    id:9,
    imgSrc:img9,
    destTitle:'Bali Island',
    location:'Indonesia',
    grade:'CULTURAL RELAX',
    fees:'$500',
    discription: ' the epitom of romance sit amet consectetur adipisicing elitSunt illo quisquam voluptatum debitis rerum, vel corrupti recusandae animi excepturi  totam veritatis cumque reiciendis dolor accusantium '

},
]